/**
 * Links to the proxied config API endpoints
 */
export class API {
    constructor ({ url, template, cacheDuration = 0 } = {}) {
        this.url = url;
        this.cacheDuration = cacheDuration;
        this.template = template;
    }
    
    getI18n (languages) {
        return fetch(`${this.url}i18n/${this.template}?${languages.map((language) => `lng[]=${language}`).join('&')}${this.cacheDuration > 0 ? `&cacheduration=${this.cacheDuration}` : ''}`).then((res) => res.json())
    }

    reportUsage (keys) {
        return fetch(`${this.url}keys/usage`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ template: this.template, keys }),
        }).catch(console.warn);
    }
    
    reportMissing (keys) {
        fetch(`${this.url}keys/missing`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ template: this.template, keys }),
        }).catch(console.warn);
    }
}
